module.exports = __webpack_public_path__ + "src/assets/img/ramblerweather.f911afb1.jpg";